"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorageKeyRepository = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocalStorageKeyRepository = function LocalStorageKeyRepository() {
  _classCallCheck(this, LocalStorageKeyRepository);

  _defineProperty(this, "getKey", function (provKeyId) {
    var _provKeyId = "browser_key_".concat(provKeyId);

    var key = window.localStorage.getItem(_provKeyId);

    if (!key) {
      return Promise.reject('Key not found.');
    }

    return Promise.resolve(key);
  });

  _defineProperty(this, "save", function (provKeyId, key) {
    var _provKeyId = "browser_key_".concat(provKeyId);

    window.localStorage.setItem(_provKeyId, key);
  });
};

var localStorageKeyRepository = new LocalStorageKeyRepository();
exports.localStorageKeyRepository = localStorageKeyRepository;